module.exports = __webpack_public_path__ + "static/img/bg-overview@t.3d247d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/bg-overview@t.jpg
// module id = o4va
// module chunks = 0